import * as React from "react";
import Typography from "@mui/material/Typography";
import Script from "next/script";

import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import { useCallback, useState } from "react";
import { useMediaQuery } from "@mui/material";

const Footer: React.FunctionComponent<{}> = () => {
  const theme = useTheme();
  const [hasVerticalScrollbar, setHasVerticalScrollbar] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const footerRefFun = useCallback(() => {
    const resizeObserver = new ResizeObserver(() => {
      const hasVerticalScroll = () => {
        if (window.innerHeight) {
          return document.body.offsetHeight > window.innerHeight;
        }
        return (
          document.documentElement.scrollHeight >
            document.documentElement.offsetHeight ||
          document.body.scrollHeight > document.body.offsetHeight
        );
      };

      const hasVScroll = hasVerticalScroll();
      if (hasVScroll) {
        setHasVerticalScrollbar(true);
      } else {
        setHasVerticalScrollbar(false);
      }
    });

    resizeObserver.observe(document.body);
  }, []);
  return (
    <Box
      sx={{
        position: hasVerticalScrollbar ? "unset" : "fixed",
        bottom: hasVerticalScrollbar ? "unset" : "0px",
        width: "100%",
      }}
      ref={footerRefFun}
    >
      <Script
        id="schema-org-organization"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://www.econut.store/#organization",
            name: "Econut",
            url: "https://www.econut.store/",
            logo: "https://www.econut.store/_next/image?url=%2Fstatic%2Fimages%2Feconut-logo1.png&w=384&q=75",
            sameAs: [
              "https://www.facebook.com/econut.fb/",
              "https://www.instagram.com/econut.store/",
              "https://www.linkedin.com/company/econutstore/",
            ],
            contactPoint: [
              {
                "@type": "ContactPoint",
                contactType: "customer support",
                telephone: "+91-8591367993",
                email: "info@econut.store",
                url: "https://www.econut.store/contact-us",
              },
            ],
          }),
        }}
      />
      <Divider sx={{ width: "100%", height: "1px" }} />
      <Box
        sx={{
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Typography
          variant="caption"
          color={theme.palette.secondary.dark}
          sx={{ textAlign: "center", fontSize: "0.9rem" }}
        >
          &copy; ECONUT {new Date().getFullYear()} All Rights Reserved.
        </Typography>
        <Typography
          variant="caption"
          color={theme.palette.secondary.dark}
          sx={{ textAlign: "center", fontSize: "0.9rem" }}
        >
          Maintained by{" "}
          <a href="https://includ.in/" target="_blank">
            includ.in
          </a>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
